import React, { useEffect, useRef } from 'react'
import Breadcrumb from './Breadcrumb/Breadcrumb'
import { motion, useAnimation, useInView, useSpring } from 'framer-motion'
import { expertiesCards, Gammaexperties, Xraysexperties } from '../utils/data'
import rays from '../assets/images/product/rays.webp'
import { GlowingCard } from './card/GlowingCard'
import { itemAnimation } from '../utils/animation'
import mission from '../assets/bg_img.jpg';
import ServicePortfolio from './Portfolio'
import xray from '../assets/images/xray.png'
const Expertise = () => {
    const sectionRef = useRef(null)

    const isInView = useInView(sectionRef, { once: false, amount: 0.1 })
    const scaleSpring = useSpring(1, { stiffness: 100, damping: 30 })

    const controls = useAnimation();
    useEffect(() => {
        if (isInView) {
            scaleSpring.set(1.1)
            controls.start("visible")
        } else {
            scaleSpring.set(1)
            controls.start("hidden")
        }
    }, [isInView, scaleSpring, controls])

    return (
        <>
            <section className="relative container mx-auto px-4" ref={sectionRef}>

                <Breadcrumb title={'Our Expertise'} />
                <motion.section
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                    className="space-y-6 py-20">
                    <div className="border-l-4 border-red-500 pl-3">
                        <motion.h2
                            className="text-3xl md:text-6xl sm:text-4xl  lg:text-5xl  font-bold tracking-tighter leading-none "
                        >
                            <motion.span
                                initial={{ x: -100, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                transition={{ duration: 0.8 }}
                                className="inline-block text-gray-400"
                            >
                                Legacy of Expertise
                            </motion.span>
                            <motion.span
                                initial={{ x: 100, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                transition={{ duration: 0.8, delay: 0.2 }}
                                className="inline-block ml-2 md:ml-4"
                                style={{ WebkitTextStroke: '1px black', color: 'transparent' }}
                            >
                                – Growing Through Understanding
                            </motion.span>
                        </motion.h2>
                    </div>
                    <motion.p
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.1 }} className="text-dark  font-lg leading-relaxed">
                        Since our founding in   <span className="text-customOrange font-bold">2014</span>, Spectra Group has believed that true expertise comes from
                        understanding real-world challenges. We began with a vision to provide high-quality
                        technical solutions and services for analytical instruments, process analyzers, and radiation
                        systems. But very quickly, we realized that technology alone is not enough.
                        Across industries like <span className="text-customOrange font-bold">cement, minerals, steel, oil & gas, and pharmaceuticals</span> , we observed
                        recurring challenges: downtime caused by operational gaps, inconsistent analyzer results,
                        and uncertainty in radiation safety practices. These experiences shaped our philosophy—our
                        mission became not just to deliver instruments or services, but to partner with our
                        customers, understand their pain points, and evolve solutions that truly add value.
                        From that moment, every decision we made was guided by the needs of our customers. We
                        began deploying engineers across the Middle East, Africa, and Turkey to ensure faster
                        onsite support. We developed hands-on training programs, preventive maintenance
                        schedules, and regulatory compliance guidance. With each project, we learned, adapted,
                        and enhanced our services to ensure reliability, safety, and operational excellence.
                    </motion.p>
                </motion.section>
            </section>

            <section ref={sectionRef}
                id="about-us"
                className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-cover bg-center bg-fixed"
                style={{
                    backgroundImage: "url(" + mission + ")"
                }} >
                <div className="absolute inset-0 bg-black bg-opacity-65" />

                <motion.div
                    initial="hidden"
                    animate={controls}
                    variants={{
                        visible: { transition: { staggerChildren: 0.1 } },
                        hidden: {}
                    }}
                    className="relative z-10 w-full"
                >
                    <div className="container mx-auto px-4 py-10">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-12">
                            {expertiesCards.map((service, index) => (
                                <motion.div
                                    key={index}
                                    className={`md:p-6 p-2 rounded-2xl shadow-md ${service.bgClass} ${service.gridClass} h-full flex flex-col`}
                                >
                                    <div className={`${"service.bgClass"} h-full rounded-lg backdrop-blur-sm    transition-all duration-500  group cursor-pointer overflow-hidden`}>
                                        <div className="relative h-full p-6 flex flex-col">
                                            <motion.div
                                                whileHover={{ scale: 1.2, rotate: 360 }}
                                                transition={{ type: "spring", stiffness: 260, damping: 20 }}
                                                className="text-white relative inline-block mb-4"
                                            >
                                                {/* {service.icon} */}
                                            </motion.div>
                                            <motion.h3
                                                className="md:text-3xl text-2xl font-bold mb-3 font-oswald"
                                                initial={{ opacity: 0.8 }}
                                                whileHover={{ opacity: 1, x: 5 }}
                                                transition={{ duration: 0.2 }}
                                            >
                                                {service.title}
                                            </motion.h3>
                                            <motion.p
                                                className="text-light text-lg group-hover:text-gray-200 transition-colors duration-300 flex-grow"
                                                initial={{ opacity: 0, y: 20 }}
                                                whileInView={{ opacity: 1, y: 0 }}
                                                transition={{ delay: 0.2, duration: 0.5 }}
                                            >
                                                {service.description}
                                            </motion.p>
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </motion.div>
            </section>
            <sction>
                <div className='relative container mx-auto px-4 "'>
                    <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 py-20 gap-6">
                        <ServicePortfolio />
                        <section className="py-20">
                            <div className="grid md:grid-cols-2 gap-12 items-center">
                                <motion.div
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.8 }}
                                    className="space-y-4"
                                >
                                    <motion.h1
                                        className="text-3xl md:text-4xl sm:text-3xl  lg:text-4xl  font-bold mb-10 tracking-wider text-custom"
                                        style={{
                                            WebkitTextStroke: '1px #b84e4a',
                                            WebkitTextFillColor: 'transparent'
                                        }}
                                    >
                                        Mission-Critical PGNAA Solutions
                                    </motion.h1>
                                    <motion.div
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.5 }}
                                        viewport={{ once: false }}
                                    >
                                        <motion.ol
                                            initial={{ opacity: 0 }}
                                            whileInView={{ opacity: 1 }}
                                            transition={{ staggerChildren: 0.1 }}
                                            viewport={{ once: false }}
                                            className="list-decimal list-inside space-y-4"
                                        >
                                            {/* <motion.p

                                                initial={{ opacity: 0, x: -50 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.5, delay: 0.1 }}
                                                // viewport={{ once: false }}
                                                className="text-md text-gray-700 font-medium"
                                            >
                                                We provide expert support for process analyzers, enabling real-time monitoring, precise
                                                measurements, and high uptime. Our team has extensive experience in optimizing systems
                                                for maximum performance, tailored to your operational needs.

                                            </motion.p> */}
                                             {Gammaexperties.map((service, index) => (
                                                <motion.li
                                                    key={index}
                                                    initial={{ opacity: 0, x: -50 }}
                                                    whileInView={{ opacity: 1, x: 0 }}
                                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                                    viewport={{ once: false }}
                                                    className="text-md text-gray-700 font-medium font-oswald"
                                                >
                                                    {service}
                                                </motion.li>
                                            ))}
                                        </motion.ol>
                                    </motion.div>


                                </motion.div>
                                <motion.div
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.8 }}
                                    className="relative"
                                >
                                    <motion.div
                                        className="relative h-[400px] overflow-hidden rounded-lg"
                                        whileHover={{ scale: 1.05 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <img
                                            src={rays}
                                            alt="Artistic visual"
                                            className="w-full h-full object-cover"
                                        />
                                        <motion.div
                                            className="absolute inset-0 bg-gradient-to-t from-customOrange to-transparent opacity-1"
                                            whileHover={{ opacity: 0.6 }}
                                            transition={{ duration: 0.3 }}
                                        />
                                    </motion.div>
                                </motion.div>
                            </div>
                            <div className="grid md:grid-cols-2 gap-12 items-center py-20">
                                <motion.div
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.8 }}
                                    className="relative"
                                >
                                    <motion.div
                                        className="relative h-[400px] overflow-hidden rounded-lg"
                                        whileHover={{ scale: 1.05 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <img src={xray} alt="X ray" className="w-full h-full object-contain" />
                                        <motion.div
                                            className="absolute inset-0 bg-gradient-to-t from-customOrange to-transparent opacity-1"
                                            whileHover={{ opacity: 0.6 }}
                                            transition={{ duration: 0.3 }}
                                        />
                                    </motion.div>
                                </motion.div>
                                <motion.div
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.8 }}
                                    className="space-y-4"
                                >
                                    <motion.h1
                                        className="text-3xl md:text-4xl sm:text-3xl  lg:text-4xl  font-bold mb-10 tracking-wider text-custom"
                                        style={{
                                            WebkitTextStroke: '1px #b84e4a',
                                            WebkitTextFillColor: 'transparent'
                                        }}
                                    >
                                        X-ray Systems
                                    </motion.h1>
                                    <motion.div
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.5 }}
                                        viewport={{ once: false }}
                                    >
                                        <motion.ol
                                            initial={{ opacity: 0 }}
                                            whileInView={{ opacity: 1 }}
                                            transition={{ staggerChildren: 0.1 }}
                                            viewport={{ once: false }}
                                            className="list-decimal list-inside space-y-4"
                                        >
                                            {Xraysexperties.map((service, index) => (
                                                <motion.li
                                                    key={index}
                                                    initial={{ opacity: 0, x: -50 }}
                                                    whileInView={{ opacity: 1, x: 0 }}
                                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                                    viewport={{ once: false }}
                                                    className="text-md text-gray-700 font-medium font-oswald"
                                                >
                                                    {service}
                                                </motion.li>
                                            ))}
                                        </motion.ol>
                                    </motion.div>


                                </motion.div>
                            </div>
                            <div>
                                <motion.div
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.8 }}
                                    className="space-y-4"
                                >
                                    <motion.h1
                                        className="text-3xl md:text-4xl sm:text-3xl  lg:text-4xl  font-bold mb-10 tracking-wider text-center text-custom"
                                        style={{
                                            WebkitTextStroke: '1px #b84e4a',
                                            WebkitTextFillColor: 'transparent'
                                        }}
                                    >
                                        Other Expertise
                                    </motion.h1>
                                    <motion.div
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.5 }}
                                        viewport={{ once: false }}
                                    >
                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            whileInView={{ opacity: 1 }}
                                            transition={{ staggerChildren: 0.1 }}
                                            viewport={{ once: false }}
                                            className="list-decimal list-inside space-y-4"
                                        >
                                            <motion.p
                                                initial={{ opacity: 0, x: -50 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.5, delay: 1 * 0.1 }}
                                                viewport={{ once: false }}
                                                className="text-md text-gray-700 font-medium"
                                            >
                                                We provide <i className='text-custom'>Radiation Support</i> and Services, advanced  <i className='text-custom'>Quarry Planning</i> and <i className='text-custom'>Mine Planning*</i> using <i className='text-custom'>3D & 2D modeling</i>, comprehensive <i className='text-custom'>Laboratory Information System design</i> integrated with <i className='text-custom'>PGNAA, X-ray, and Quarry Data</i>, as well as specialized <i className='text-custom'>Environmental services and equipment supply</i> to enhance operational efficiency and compliance.
                                            </motion.p>
                                        </motion.div>
                                    </motion.div>


                                </motion.div>
                            </div>
                        </section>
                    </div>
                </div>
            </sction>

        </>
    )
}

export default Expertise
